import { putPricingSheetItems } from '../services/pricingSheetItems';
import { formatPricingSheetItemsPost } from './postSheetRows';

const putSheetRows = async (
  pricingSheetId: string,
  pricingSheetRows: any,
) => {
  const response = await putPricingSheetItems(
    pricingSheetId,
    formatPricingSheetItemsPost(pricingSheetId, pricingSheetRows),
  );

  return response;
};

export default putSheetRows;
